import { render, staticRenderFns } from "./target-config-input.vue?vue&type=template&id=3890739e&"
import script from "./target-config-input.vue?vue&type=script&lang=js&"
export * from "./target-config-input.vue?vue&type=script&lang=js&"
import style0 from "./target-config-input.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports